import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import withAuth from "../../hocs/withAuth";
import withApp from "../../hocs/withApp";
import Header from "./components/header";
import Search from "./components/search";
import { Divider } from "@mui/material";
import Customer from "./components/customer";
import Details from "./components/details";
import Bottom from "./components/bottom";
import useLocalStorage from "../../hooks/useLocalStorage";
import { useNavigate, useParams } from "react-router-dom";
import { useBackdropContext } from "../../contexts/backdrop/BackdropProvider";
import {
  asyncPostData,
  asyncPutData,
  asyncSearchList,
} from "../../utils/httpRequests";
import { useDispatch, useSelector } from "react-redux";
import { useAlertContext } from "../../contexts/alert/AlertProvider";
import { v4 } from "uuid";
import moment from "moment";
import {
  updateCurrentHd,
  updateOneHd,
} from "../../redux/reducers/order.reducer";
import { cloneDeep } from "lodash";

const heights = {
  header: "60px",
};

type OrderContextType = {
  selectMulti: boolean;
  giamGia: { gia_tri: number; so_luong: number };
  originHd: any;
  pttts: any[];
  saveHd: (trang_thai: number) => any;
  setSelectMulti: Dispatch<SetStateAction<any>>;
  handleUpdateCurrentHd: (obj: { [key: string]: any }) => void;
  handleAddProductToDetails: (args: {
    product: any;
    gia_ban_le: number;
    ma_dvt: string;
    ten_dvt: string;
  }) => void;
};
const OrderContext = createContext<OrderContextType>({
  selectMulti: false,
  giamGia: { gia_tri: 0, so_luong: 0 },
  originHd: {},
  pttts: [],
  saveHd: () => {},
  setSelectMulti: () => {},
  handleUpdateCurrentHd: () => {},
  handleAddProductToDetails: (args) => {},
});
const apiCode = "pbl_nh";

function OrderPage() {
  const params = useParams();
  const token = useSelector((state: any) => state.auth.token);
  const profile = useSelector((state: any) => state.auth.profile);
  const app = useSelector((state: any) => state.app.data);
  const { currentStore, currentHd } = useSelector((state: any) => state.order);
  const { showAlert } = useAlertContext();
  const { setOpenBackdrop } = useBackdropContext();
  const [selectMulti, setSelectMulti] = useLocalStorage<boolean>(
    "order_select_mode",
    true
  );
  const [pttts, setPttts] = useState<any[]>();
  const [table, setTable] = useState<any>();
  const hdRef = useRef<any>();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  type handleAddProductToDetailsType = {
    product: any;
    gia_ban_le: number;
    ma_dvt: string;
    ten_dvt: string;
  };
  const handleAddProductToDetails = ({
    product,
    gia_ban_le,
    ma_dvt,
    ten_dvt,
  }: handleAddProductToDetailsType) => {
    if (!currentHd) return;
    const { ma_vt, ten_vt, gia_mua, ma_nvt, ten_nvt } = product;
    const detailData = {
      _id: v4(),
      is_new: true,
      ghi_chu: "",
      ma_vt,
      ten_vt,
      ma_nvt,
      ten_nvt,
      ma_dvt,
      ten_dvt,
      gia_ban: gia_ban_le,
      gia_ban_nt: gia_ban_le,
      gia_ban_le_goc: gia_ban_le,
      gia_von: gia_mua,
      gia_von_nt: gia_mua,
      sl_order: 1,
      sl_xuat: 0,
      tien_hang: gia_ban_le,
      tien_hang_nt: gia_ban_le,
      tien_ck: 0,
      tien_ck_nt: 0,
      ty_le_ck: 0,
      tien: gia_ban_le,
      tien_nt: gia_ban_le,
      tien_xuat: gia_ban_le,
      tien_xuat_nt: gia_ban_le,
      tk_dt: "51111",
      tk_gv: "6321",
      tk_vt: "1561",
    };
    const currentHdClone = cloneDeep(currentHd);

    const existedDetail = (currentHdClone?.details || []).find(
      (item: any) => item.ma_vt === product.ma_vt
    );
    if (!!existedDetail) {
      existedDetail.sl_order += 1;
      // existedDetail.sl_xuat = existedDetail.sl_order;
      const tienCk: number =
        Math.floor(
          ((existedDetail.ty_le_ck || 0) *
            (existedDetail.gia_ban_le_goc || 0)) /
            100
        ) * existedDetail.sl_order;
      existedDetail.tien_ck_nt = tienCk;
    } else {
      currentHdClone.details.push(detailData);
    }
    handleUpdateCurrentHd({ details: currentHdClone.details });
  };

  const handleUpdateCurrentHd = (updateData: { [key: string]: any }) => {
    const hdData = { ...currentHd, ...updateData };
    dispatch(updateOneHd(hdData));
  };

  const initHd = async () => {
    const resp = await asyncSearchList({
      apiCode: "pbl_nh",
      token,
      idApp: app?._id,
      condition: {
        page: 1,
        limit: 99999,
        q: {
          ma_ban: table?.ma_ban,
          ma_kho: table?.ma_kho || "",
          trang_thai: "1",
        },
      },
    });
    if (resp?.status === 200) {
      const hd = resp?.data?.[0];
      // nếu đã có hóa đơn thì lấy, không tì tạo mới
      if (!hd) {
        const newHd = {
          _id: v4(),
          ma_kho: currentStore?.ma_kho || "",
          ten_kho: currentStore?.ten_kho || "",
          ma_ban: table?.ma_ban || "",
          ten_ban: table?.ten_ban || "",
          pt_thanh_toan: "",
          ten_pt_thanh_toan: "",
          is_new: true,
          ma_kh: "",
          ten_kh: "",
          t_tien_nt: 0,
          t_ck_nt: 0,
          tien_ck_hd: 0,
          ty_le_ck_hd: 0,
          t_tt_nt: 0,
          tien_thu: 0,
          phai_tra: 0,
          exfields: {},
          details: [],
          evouchers: [],
          dien_giai: "",
          date_created: moment().toISOString(),
          user_created: profile?.email || "",
        };
        hdRef.current = newHd;
        dispatch(updateCurrentHd(newHd));
      } else {
        hdRef.current = hd;
        dispatch(updateCurrentHd(hd));
      }
    } else {
      showAlert({
        type: "error",
        message:
          resp?.data?.error ||
          resp?.data?.message ||
          "Lỗi khi tải thông tin hóa đơn",
      });
    }
  };

  const getTable = async () => {
    if (!params?.ma_kho || !params?.ma_ban) return;
    try {
      setOpenBackdrop?.(true);
      const resp = await asyncSearchList({
        apiCode: "dmban2",
        token,
        idApp: app?._id,
        condition: {
          page: 1,
          limit: 1,
          q: { ma_kho: params.ma_kho, ma_ban: params.ma_ban },
        },
      });
      if (resp?.status !== 200) {
        showAlert({
          type: "error",
          message:
            resp?.data?.error ||
            resp?.data?.message ||
            "Lỗi khi tải thông tin bàn",
        });
        return;
      }
      if (resp?.data?.[0]) {
        setTable(resp?.data?.[0]);
      } else {
        navigate("/fnb/tables");
      }
    } finally {
      setOpenBackdrop?.(false);
    }
  };

  const getPttts = async () => {
    setOpenBackdrop?.(true);
    const resp = await asyncSearchList({
      apiCode: "ptthanhtoan",
      token,
      idApp: app?._id,
      condition: { page: 1, limit: 999999 },
    });
    if (resp?.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error ||
          resp?.data?.message ||
          "Lỗi khi tải phương thức thanh toán",
      });
      setOpenBackdrop?.(false);
      return;
    }
    setPttts(resp?.data || []);
    setOpenBackdrop?.(false);
  };
  const initData = () => {
    getPttts();
  };
  const saveHd = async (trang_thai = 0) => {
    const { _id, is_new, details, ...fields } = currentHd;
    const method = !is_new ? asyncPutData : asyncPostData;
    const hdToSave = {
      ...fields,
      trang_thai,
      details: details.map((detail: any) => {
        const { _id, ...detailData } = detail;
        return {
          ...detailData,
        };
      }),
    };
    if (!hdToSave.ma_kh) {
      showAlert({
        type: "warning",
        message: "Vui lòng chọn khách hàng",
      });
      return;
    }
    if (hdToSave.tien_thu < hdToSave.t_tt_nt && trang_thai === 5) {
      showAlert({ type: "warning", message: "Số tiền thu chưa đủ" });
      return;
    }
    if (!hdToSave.pt_thanh_toan && trang_thai === 5) {
      showAlert({
        type: "warning",
        message: "Vui lòng chọn phương thức thanh toán",
      });
      return;
    }

    setOpenBackdrop?.(true);
    const resp = await method({
      apiCode,
      data: hdToSave,
      id: _id,
      token,
      idApp: app?._id,
    });
    if (resp?.status !== 200) {
      showAlert({
        type: "error",
        message:
          resp?.data?.error || resp?.data?.messsage || "Lỗi khi lưu hóa đơn",
      });
      setOpenBackdrop?.(false);
      return;
    }
    showAlert({
      type: "success",
      message: trang_thai === 1 ? "Đã gửi bếp" : "Đã thanh toán",
    });
    await asyncPutData({
      apiCode: "dmban2",
      token,
      idApp: app?._id,
      id: table._id,
      data: { trang_thai: trang_thai === 1 ? 1 : 0 },
    });
    navigate("/fnb/tables");
    setOpenBackdrop?.(false);
    return resp?.data;
  };

  const giamGia: { gia_tri: number; so_luong: number } = useMemo(() => {
    if (!currentHd) return { gia_tri: 0, so_luong: 0 };
    let giaTri = 0;
    let soLuong = 0;
    let item;
    for (let i = 0; i < currentHd.details.length; i++) {
      item = currentHd.details[i];

      if (item.tien_ck_nt > 0) {
        giaTri += item.tien_ck_nt;
        soLuong += 1;
      }
    }
    return {
      gia_tri: giaTri,
      so_luong: soLuong,
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentHd]);

  useEffect(() => {
    if (table) {
      initHd();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [table?.ma_ban]);

  useEffect(() => {
    getTable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.ma_kho, params?.ma_ban]);

  useEffect(() => {
    initData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <OrderContext.Provider
      value={{
        selectMulti,
        giamGia,
        originHd: hdRef.current,
        pttts: pttts || [],
        saveHd,
        setSelectMulti,
        handleUpdateCurrentHd,
        handleAddProductToDetails,
      }}
    >
      <Header height={heights.header} />
      <Search />
      <Divider />
      <Customer />
      <Details />
      <Bottom />
    </OrderContext.Provider>
  );
}

export default withAuth(withApp(OrderPage));

export const useOrderContext = () => {
  const value = useContext(OrderContext);
  if (!value) {
    throw new Error("OrderContext must be used inside OrderProvider");
  }
  return value;
};
